import Vue from 'vue';
import Router from 'vue-router';
import store from '@/vuex/store';
import { routerCheck, isLogin, logOut } from '@/api/userMG'
import ElementUI from 'element-ui';
import { isMobile } from '@/utils/device';
// 启用路由
Vue.use(Router);
const getBasePath = () => {
    console.log('切换了项目名清空session触发退出接口');
    const oldSegment = sessionStorage.getItem('firstSegment');
    const currentPath = window.location.pathname;
    const firstSegment = currentPath.split('/')[2] || '';
    console.log('当前项目名：' + firstSegment);
    if (oldSegment !== firstSegment) {
        console.log('执行退出接口');
        logOut();
        sessionStorage.clear();
    }
    sessionStorage.setItem('firstSegment', firstSegment);
    return firstSegment ? `/${firstSegment}` : '/kmsm';
};

// 导出路由
const router = new Router({
    mode: 'history', // 将 hash 模式改为 history 模式取消/#/
    base: '/web/' + getBasePath(),
    routes: [{
            path: '/',
            name: 'index',
            component: () => isMobile() ?
                import ('@/views/mobile/index.vue') : import ('@/views/index.vue'),
            children: [{
                    path: '',
                    component: () =>
                        import ('@/components/waist.vue'), // 默认中部信息
                },
                {
                    path: '/examarea', //主机模拟考区选择
                    component: () =>
                        import ('@/views/examarea.vue'),
                },
                {
                    path: '/appraisal', //鉴定点
                    component: () =>
                        import ('@/views/appraisal.vue'),
                },
                {
                    path: '/alldevice', // 系统结构原理图
                    component: () =>
                        import ('@/views/alldevice.vue'),
                },
                {
                    path: '/instructions', //学习使用说明
                    component: () =>
                        import ('@/views/instructions.vue'),
                },

                {
                    path: '/theory', // 理论题库页
                    component: () =>
                        import ('@/views/theory.vue'),
                },
                {
                    path: '/examcontent', // 理论题库详情页
                    component: () =>
                        import ('@/views/examcontent.vue'),
                },
                {
                    path: '/examsection', // 理论题库考试页
                    component: () =>
                        import ('@/views/examsection.vue'),
                },
                {
                    path: '/vision', // 理论视频页
                    component: () =>
                        import ('@/views/vision.vue'),
                },
                {
                    path: '/visionvideo', // 理论视频观看页
                    component: () =>
                        import ('@/views/visionvideo.vue'),
                },
                {
                    path: '/visual', // 实操视频页
                    component: () =>
                        import ('@/views/visual.vue'),
                },
                {
                    path: '/visualvideo', // 实操视频观看页
                    component: () =>
                        import ('@/views/visualvideo.vue'),
                },
                {
                    path: '/resourcebuy', // 资源购买页
                    component: () =>
                        import ('@/views/resourcebuy.vue'),
                },
                {
                    path: '/personalcenter', // 个人中心页
                    component: () =>
                        import ('@/views/personalcenter.vue'),
                },
                {
                    path: '/exampage', // 其他页面
                    component: () =>
                        import ('@/views/exampage.vue'),
                },
                {
                    path: '/intermediate', // 资源页
                    component: () =>
                        import ('@/views/intermediate.vue'),
                },
            ],
        }, {
            path: '/login',
            name: 'login',
            component: () => isMobile() ?
                import ('@/views/mobile/log.vue') : import ('@/views/log.vue'),
        },
        {
            path: '/404',
            name: '404',
            component: () =>
                import ('@/views/404.vue')
        },
        {
            path: '*',
            redirect: '/404'
        },
        {
            path: '/purchased', // 已购资源页
            component: () =>
                import ('@/views/mobile/Purchased.vue'),
        },
        {
            path: '/purchase', // 资源购买页
            component: () =>
                import ('@/views/mobile/Purchase.vue'),
        },
        {
            path: '/profilepage', // 个人中心
            component: () =>
                import ('@/views/mobile/ProfilePage.vue'),
        },
        {
            path: '/passwordchange', // 修改密码
            component: () =>
                import ('@/views/mobile/PasswordChange.vue'),
        },
        {
            path: '/aboutus', // 关于我们
            component: () =>
                import ('@/views/mobile/AboutUs.vue'),
        },
        {
            path: '/courselearning', // 课程学习
            component: () =>
                import ('@/views/mobile/courselearning.vue'),
        },
        {
            path: '/examdetail', // 主机模拟页
            component: () =>
                import ('@/views/mobile/ExamDetail.vue'),
        },
        {
            path: '/examrourl', // 主机模拟页
            component: () =>
                import ('@/views/mobile/area/ExamRourl.vue'),
        },
        {
            path: '/chapterpractice', // 章节练习页
            component: () =>
                import ('@/views/mobile/questionbank/ChapterPractice.vue'),
        },
        {
            path: '/answerpage', // 做题页
            component: () =>
                import ('@/views/mobile/questionbank/AnswerPage.vue'),
        },
        {
            path: '/historytable', // 历史成绩页
            component: () =>
                import ('@/views/mobile/questionbank/HistoryTable.vue'),
        },
        {
            path: '/visionvideoa', //理论视频页
            component: () =>
                import ('@/views/mobile/course/VisionVideo.vue'),
        },
        {
            path: '/visualvideoa', //理论视频页
            component: () =>
                import ('@/views/mobile/course/VisualVideo.vue'),
        },


    ]
});
router.beforeEach(async(to, from, next) => {
    // 定义无需拦截
    const FREE_PATHS = ['/login', '/404', '/', '/purchase', '/purchased', '/profilepage', '/passwordchange', '/courselearning', '/aboutus', '/instructions'];
    // 定义需要设备验证的路径
    const NO_AUTH_PATHS = ['/examarea', '/appraisal', '/theory', '/vision', '/visual', '/resourcebuy', '/intermediate', '/alldevice', '/appraisal'];
    // 定义手机端端当跨页面等
    const NO_AUTH_PATH = ['/examdetail', '/historytable', '/answerpage', '/chapterpractice', '/visionvideoa', '/visualvideoa'];
    // 定义资源购买路径
    const RESOURCE_BUYS_PATH = '/resourcebuy';
    // if (!window.location.pathname.startsWith('/web/kmsm')) {
    //     window.location.href = '/web/kmsm' + to.fullPath;
    //     return;
    // }
    // if (to.path === from.path) {
    //     return next(false) // 阻止重复导航
    // }

    // 1. 检查是否手机端 进入详情页判断直接进入
    if (isMobile()) {
        if (NO_AUTH_PATH.includes(to.path)) {
            if (!localStorage.getItem('currentLevel') || !localStorage.getItem('examAreaId')) {
                // 如果 localStorage 项缺失，返回首页
                return next({ path: '/' });
            } else {
                return next();
            }
        }
    }
    // 1. 免登录路径
    if (FREE_PATHS.includes(to.path)) {
        return next();
    }


    // 2. 检查是否登录（timestamp存在）
    if (!sessionStorage.getItem('timestamp')) {
        ElementUI.Message({ message: '请登录后再访问！', type: 'err' });
        console.log('路由拦截请登录后再访问！');
        sessionStorage.clear();
        return next({ path: '/login' });
    }

    // 3. 特殊路径/resourcebuy的权限检查
    if (to.path === RESOURCE_BUYS_PATH) {
        const role = store.state.HomeInfo.is_purchase_enabled;
        if (!role) {
            ElementUI.Message({ message: '该组织无权使用资源购买', type: 'err' });
            return next(false);
        }
        return next();
    }
    const identifier_type = localStorage.getItem('deviceType');
    const identifier_value = localStorage.getItem('deviceId');
    // 4. 需要设备验证的路径
    if (NO_AUTH_PATHS.includes(to.path)) {
        try {
            const plainTimestamp = Math.floor(Date.now() / 1000);

            let authParams = {};

            if (identifier_type === 'computer') {
                authParams = {
                    encrypted_timestamp: btoa(JSON.stringify({
                        timestamp: plainTimestamp,
                        value: identifier_value,
                    })),
                    wechat_id: ''
                };
            } else if (identifier_type === 'wechat') {
                authParams = {
                    encrypted_timestamp: '',
                    wechat_id: ''
                };
            } else {
                throw new Error('未知的设备类型');
            }
            //  打印请求时间戳
            // const timess = Math.floor(Date.now() / 1000);
            // console.log("打印的时间戳" + timess);
            const response = await routerCheck(
                identifier_type,
                plainTimestamp,
                authParams.encrypted_timestamp,
                authParams.wechat_id
            );
            console.log(response);
            if (response.code !== 200) {
                ElementUI.Message({
                    message: response.message + '设备验证失败,请刷新页面重试！',
                    type: 'error'
                });
                return next({ path: '/' });
            }
        } catch (error) {
            console.error('路由守卫验证失败:', error);
            ElementUI.Message({
                message: '设备验证异常，请稍后重试',
                type: 'error'
            });
            // return next({ path: '/404' });
        }
    } else {
        // 5. 其他情况放行
        return next();
    }
    // 6. 登录验证
    const res = await isLogin(
        identifier_type, identifier_value
    );
    if (res.code != 200 && res.code != 404) {
        sessionStorage.removeItem('name');
        sessionStorage.removeItem('phone');
        sessionStorage.removeItem('role');
        ElementUI.Message({
            message: res.message || '登录已过期，请重新登录',
            type: 'error',
            duration: 3000
        });
        return next({ path: '/login' });
    }

    // 7. 其他情况放行
    return next();
});
router.onError((error) => {

    console.log('路由错误:', error);
});
export default router;